
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/english",
      function () {
        return require("private-next-pages/english/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/english"])
      });
    }
  